






























































































































































import {Component, Vue} from "vue-property-decorator";
import CoverSection from "@/sections/CoverSection.vue";
import FeatureList from "@/components/FeatureList.vue";
import ContentSection from "@/sections/ContentSection.vue";
import FeatureSection from "@/sections/FeatureSection.vue";
import PricingSection from "@/sections/PricingSection.vue";
import Question from "@/components/Question.vue";

@Component({
    components: {
        Question, PricingSection, FeatureSection, FeatureList, CoverSection, ContentSection
    },
    beforeRouteEnter(to, from, next) {
        next(component => (component as Home).scrollToComponent(to.path.substr(1)));
    },
    beforeRouteUpdate(to, from, next) {
        (this as Home).scrollToComponent(to.path.substr(1));
        next();
    }
})
export default class Home extends Vue {
    scrollTo(pos: number) {
        window.scrollTo({top: pos, behavior: "smooth"});
    }

    scrollToComponent(id: string): void {
        if (id === "") {
            this.scrollTo(0);
        } else {
            const elem = document.getElementById(id);
            if (elem) {
                window.scrollTo({top: elem.offsetTop, behavior: "smooth"});
            }
        }
    }
}
